import * as React from "react";
import PasosContainer from "../containers/pasos-container";

export default function PasosPage() {
  return <PasosContainer></PasosContainer>;
}
